import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) {
    console.log(route);
    route.url.subscribe(
        (routeUrl) => {
          if(routeUrl[0] && routeUrl[0].path === 'login') {
            router.navigate(['/']);
          }
        });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/main/main.component.ts